import "./quiz-navigation-row.component.css";

import FactCheckIcon from "@mui/icons-material/FactCheck";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box, IconButton } from "@mui/material";

export interface QuizNavigationRowProps {
  onPreviousPageClicked: () => void;
  onNextPageClicked: () => void;
  firstPage: boolean;
  lastPage: boolean;
}

export function QuizNavigationRow(props: QuizNavigationRowProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: props.firstPage ? "end" : "space-between",
        margin: "0",
        // backgroundColor: "lightblue",
      }}
      bgcolor={"quizNavigationRow.main"}
    >
      <IconButton
        onClick={props.onPreviousPageClicked}
        size="large"
        sx={{
          display: props.firstPage ? "none" : "initial",
        }}
      >
        <Box
          sx={{
            display: props.firstPage ? "none" : "flex",
            backgroundColor: "quizNavigationButton.main",
            color: "quizNavigationButton.contrastText",
            alignItems: "center",
            padding: "5px",
          }}
        >
          <NavigateBeforeIcon fontSize="large" /> BACK
        </Box>
      </IconButton>
      <IconButton onClick={props.onNextPageClicked} size="large">
        <Box
          sx={{
            backgroundColor: "quizNavigationButton.main",
            color: "quizNavigationButton.contrastText",
            padding: "5px",
          }}
        >
          <Box
            sx={{
              display: props.lastPage ? "none" : "flex",
              alignItems: "center",
            }}
          >
            NEXT{" "}
            <NavigateNextIcon
              fontSize="large"
              sx={{
                display: props.lastPage ? "none" : "initial",
              }}
            />
          </Box>
          <Box
            sx={{
              display: props.lastPage ? "flex" : "none",
              alignItems: "center",
            }}
          >
            SUBMIT{" "}
            <FactCheckIcon
              fontSize="large"
              sx={{
                paddingLeft: "5px",
                display: props.lastPage ? "initial" : "none",
              }}
            />
          </Box>
        </Box>
      </IconButton>
    </Box>
  );
}
